import { GlobeHemisphereEast } from "@phosphor-icons/react";
import { useSeo, breadcrumbs } from "@/lib/seo";
import { PublicShell, Crumbs } from "@/components/PublicShell";
import { ShareBar } from "@/components/ShareBar";
import { WorldBoard } from "@/components/WorldBoard";

export default function WorldMarketsPublic() {
  useSeo({
    title: "Live world share market board — 27 indices, region heat map and today's read | Unity & Utility",
    description: "Live share index levels across the Americas, Europe, Asia-Pacific and the Middle East, with a region heat map, the day's biggest risers and fallers, and what the moves mean for importing, freight and borrowing.",
    path: "/world-markets",
    jsonLd: breadcrumbs([["Home", "/"], ["Markets", "/markets"], ["World board", "/world-markets"]]),
  });

  return (
    <PublicShell>
      <div className="mx-auto max-w-6xl px-5 py-10 sm:px-8 sm:py-14" data-testid="world-public-page">
        <Crumbs items={[["Home", "/"], ["Markets", "/markets"], ["World board", null]]} />
        <p className="overline text-[#B3241B]">Live world board</p>
        <h1 className="font-display mt-2 flex items-start gap-3 text-4xl font-bold leading-[1.08] tracking-tight text-[#0F172A] sm:text-5xl">
          <GlobeHemisphereEast size={38} className="mt-1 shrink-0 text-[#002FA7]" weight="duotone" />
          World share markets, region by region
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
          Every major share index across the Americas, Europe, Asia-Pacific and the Middle East on
          one board — refreshed through the day, with the biggest risers and fallers and a plain
          read of what the moves mean if you import parts, run vans and borrow to fund stock.
        </p>
        <div className="mt-6">
          <ShareBar url={`${window.location.origin}/world-markets`} text="Live world share market board from Unity & Utility" testid="world-public-share" compact />
        </div>
        <div className="mt-8"><WorldBoard /></div>
      </div>
    </PublicShell>
  );
}
